var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77 8.936a3.635 3.635 0 100-7.27 3.635 3.635 0 000 7.27zM16.038 21.051H1.5v-1.615a7.27 7.27 0 1114.538 0v1.615zM15.23 1.667a3.635 3.635 0 010 7.269M17.814 12.474a7.27 7.27 0 014.685 6.784v1.793h-2.423",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUsers;